module.exports = __webpack_public_path__ + "img/FB-Icon.5eccf736.png";